<script setup lang="ts">
  import Hero from '@/domains/investor/components/Hero/Hero.vue'
  import { BsTabs } from '@afo/bsf-core'

</script>

<template>
  <Hero
    :title="$t('investor.corporateGovernance.corporateDocuments.hero.title')"
    :lead="$t('investor.corporateGovernance.corporateDocuments.hero.lead')"
    image="/images/investor/corporate-governance/corporate-documents/hero/Hero.png"
    :first-button="{
      text: $t('investor.corporateGovernance.corporateDocuments.hero.firstButton.label'),
      to: $t('investor.corporateGovernance.corporateDocuments.hero.firstButton.url'),
    }"
  />
</template>
